import axios from "axios";
import EditIcon from "@mui/icons-material/BorderColor";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { hoverScale } from "../../../components/DesignStandardize";
import AdminEditLeaveApplication from "./AdminEditLeaveApplication";

const Pending = ({ id }) => {
  const [approve, setApprove] = useState(false);
  const [disapprove, setDisapprove] = useState(false);
  const [leaveInfo, setLeaveInfo] = useState("");
  const [leaveDetails, setLeaveDetails] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [singleLeaveInfo, setSingleLeaveInfo] = useState("");
  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  let myEmployeeId = null;

  const toggleEditModal = () => {
    setShowEditModal((prevShowEditModal) => !prevShowEditModal);
  };

  // Function to get leave information by Employee ID
  const getLeaveDetailsByEmployeeId = async (employeeId) => {
    try {
      const response = await axios.get(`${apiUrl}/leave/detailsEmpID/${employeeId}`);
      setLeaveDetails(response.data.data); // Update state with fetched data
      console.log("Leave details fetched from API:", response.data.data); // Log the fetched data directly
    } catch (error) {
      console.error("Error fetching leave details by Employee ID:", error);
    }
  };

  // Function to handle leave approval
  const handleApproveChange = async () => {
    setApprove(!approve);
    try {
      await updateLeaveForEmployees();
      const data = {
        Status: 1,
      };

      await axios.put(`${apiUrl}/leave/update/${id}`, data);
      toast.success("Leave has been Approved");
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } catch (error) {
      toast.error("An error has occurred!");
      console.error(error);
    }
    if (!approve) {
      setDisapprove(false);
    }
  };

  const updateLeaveForEmployees = async () => {
    try {
      const data = {
        totalDates: leaveInfo.Total,
      };
      if (leaveInfo.Type === "Sick") {
        await axios.put(
          `${apiUrl}/employee/ELeaveUpdate/${leaveInfo.EmployeeID}`,
          data
        );
      } else {
        await axios.put(
          `${apiUrl}/employee/CLeaveUpdate/${leaveInfo.EmployeeID}`,
          data
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getIndividualLeaveInfo = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/employee/${leaveInfo.EmployeeID}`
      );
      setSingleLeaveInfo(response.data.employeeInfo);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (leaveInfo.EmployeeID) {
      myEmployeeId = leaveInfo.EmployeeID;
      console.log("Updated myEmployeeId:", myEmployeeId);

      // Fetch leave details by Employee ID
      getLeaveDetailsByEmployeeId(myEmployeeId);

      // Fetch additional individual leave info
      getIndividualLeaveInfo();
    }
  }, [leaveInfo.EmployeeID]);

  const getLeaveInformation = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/leave/detailsByLeaveID/${id}`
      );
      setLeaveInfo(response.data.leaves);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getLeaveInformation();
  }, [id]);

  const handleDisapproveChange = async () => {
    setDisapprove(!disapprove);
    try {
      const data = {
        Status: 2,
      };
      await axios.put(`${apiUrl}/leave/update/${id}`, data);
      toast.success("Leave Application Denied!!");
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } catch (error) {
      console.error(error);
    }
    if (!disapprove) {
      setApprove(false);
    }
  };



  return (
    <>
      <div className="flex p-5 flex-col flex-wrap lg:flex-row gap-6 md:divide-x md:divide-gray-200">
        {/*FIRST-SECTION APPLICATION*/}
        <div className="flex-1 px-4">
          {/* Content for the first section */}
          <h2 className="text-base font-semibold mb-4 text-gray-800">Application Details</h2>

          <div className="space-y-3">
            <p className="text-sm"><span className="font-medium text-gray-700">Name:</span> <span className="text-gray-900">{leaveInfo.Name}</span></p>

            <p className="text-sm">
              <span className="font-medium text-gray-700">Applied Date:</span> <span className="text-gray-900">{leaveInfo.DateApplied}</span>
            </p>

            <div>
              <p className="text-sm font-medium text-gray-700 mb-1">Leave Dates:</p>
              {leaveInfo.Date ? (
                <ul className="text-sm text-gray-900 ml-4 space-y-1">
                  {JSON.parse(leaveInfo.Date).map((date, index) => (
                    <li key={index} className="list-disc">{format(new Date(date), "yyyy-MM-dd")}</li>
                  ))}
                </ul>
              ) : (
                <span className="text-sm text-gray-500">No leave dates available.</span>
              )}
            </div>

            <p className="text-sm"><span className="font-medium text-gray-700">Cause:</span> <span className="text-gray-900">{leaveInfo.Cause}</span></p>

            <p className="text-sm">
              <span className="font-medium text-gray-700">Leave Type:</span> <span className="text-gray-900">{leaveInfo.Type}</span>
            </p>

            <p className="text-sm">
              <span className="font-medium text-gray-700">Address:</span> <span className="text-gray-900">{leaveInfo.Address}</span>
            </p>

            <p className="text-sm">
              <span className="font-medium text-gray-700">Contact:</span> <span className="text-gray-900">{leaveInfo.Contact}</span>
            </p>
          </div>
        </div>

        {/* SECOND-SECTION LEAVE STATUS */}
        <div className="flex-1 px-4">
          {/* Content for the second section */}
          <h2 className="text-base font-semibold mb-4 text-gray-800">Leave Status</h2>

          <table className="min-w-full text-sm border border-gray-200 rounded-lg">
            <thead className="border-b bg-gray-50">
              <tr>
                <th scope="col" className="px-4 py-2.5 text-center font-medium text-gray-700">Total</th>
                <th scope="col" className="px-4 py-2.5 text-center font-medium text-gray-700">Taken</th>
                <th scope="col" className="px-4 py-2.5 text-center font-medium text-gray-700">Due</th>
              </tr>
            </thead>
            <tbody>
            <tr className="text-center border-b">
            <td className="px-4 py-2.5 bg-blue-50 font-medium">
              {leaveDetails?.remainingLeaves?.TotalLeave || 0}
            </td>
            <td className="px-4 py-2.5 bg-red-50 font-medium">
              {leaveDetails?.remainingLeaves?.TotalLeave - leaveDetails?.remainingLeaves?.TotalDue || 0}
            </td>
            <td className="px-4 py-2.5 bg-green-50 font-medium">
              {leaveDetails?.remainingLeaves?.TotalDue || 0}
            </td>
          </tr>
            </tbody>
          </table>

          <p className="text-sm text-gray-800 mt-3 font-medium">
            Current Request: {leaveInfo.Total} days
          </p>
        </div>

        {/* THIRD SECTION GIVE APPROVAL */}
        <div className="flex-1 px-4">
          <h2 className="text-base font-semibold mb-4 text-gray-800">Approval</h2>

          <p className="text-sm text-gray-700 mb-4">
            Review and approve this application:
          </p>

          <div className="flex items-center mb-3">
            <input
              id="approve-checkbox"
              type="checkbox"
              value=""
              checked={approve}
              onChange={handleApproveChange}
              className="w-4 h-4 text-green-600 bg-gray-100 border-gray-300 rounded focus:ring-green-500"
            />
            <label
              htmlFor="approve-checkbox"
              className="ms-2 text-sm font-medium text-gray-900"
            >
              Approve
            </label>
          </div>

          <div className="flex items-center mb-4">
            <input
              id="disapprove-checkbox"
              type="checkbox"
              onChange={handleDisapproveChange}
              checked={disapprove}
              value=""
              className="w-4 h-4 text-red-600 bg-gray-100 border-gray-300 rounded focus:ring-red-500"
            />
            <label
              htmlFor="disapprove-checkbox"
              className="ms-2 text-sm font-medium text-gray-900"
            >
              Disapprove
            </label>
          </div>

          <button
            className={`flex items-center text-sm text-blue-600 hover:text-blue-700 font-medium ${hoverScale}`}
            onClick={toggleEditModal}
          >
            <EditIcon fontSize="small" className="mr-1" />
            <span>Edit Dates</span>
          </button>
        </div>
      </div>
      {showEditModal && (
        <div className="z-10 fixed inset-0 flex items-center justify-center">
          <div
            className="bg-black bg-opacity-50 fixed inset-0"
            onClick={toggleEditModal}
          />
          <div className="card bg-white z-20 p-4 modal-white flex flex-col gap-3">
            <div className="card-title flex justify-between">
              <h2 className="text-center text-transparent bg-clip-text bg-gradient-to-b from-[#6782e6] to-[#214DED] md:font-extrabold m-0">
                Edit Dates Applied for Leave
              </h2>
              <CloseIcon
                onClick={toggleEditModal}
                fontSize="1px"
                className={`hover:cursor-pointer hover:bg-[#414141] w-5 h-5 hover:text-white rounded-full p-[1px] ${hoverScale}`}
              />
            </div>
            <AdminEditLeaveApplication id={id} dates={leaveInfo.Date} />
          </div>
        </div>
      )}
    </>
  );
};

export default Pending;
